import { Divider, Stack, Typography } from '@mui/material';
import Box from '@mui/material/Box';
import * as React from 'react';
import { VerticalStepperStyles } from './styles';



export const VerticalLinearStepper = ({ data = [], icon = "", customTrack = false }) => {
console.log(data)
    const classes = VerticalStepperStyles()


    return (
        <Box>
            {data?.map((x, index) => (
                <Box display={"flex"}>
                    <Box>
                        {/* circleIcon */}
                        <Box className={customTrack ? classes.applybackground : ""}>
                            <Box display="flex" alignItems={"center"}>{x?.icon}</Box>
                        </Box>
                        {/* connector */}
                        {index !== data.length - 1 &&
                            <div className={customTrack ? `${classes.customconnector}` : `${classes.connector}`}></div>
                        }
                    </Box>
                    <Box className={`${classes.detail}`}>
                        {/* name */}
                        <Typography className={`${classes.Name}`}>{x.name}</Typography>
                        {x?.notes?.length > 0 &&
                            <Typography className={classes.notes}>
                                Notes : {x?.notes}
                            </Typography>
                        }
                        {/* description */}
                        <Stack
                            direction="row"
                            divider={<Divider orientation="vertical" flexItem sx={{ marginInline: '8px' }} />}
                            mt={0.5}
                        >
                            <Typography className={`${classes.description}`}>&#x202a;{x.date}&#x202c;</Typography>
                            <Typography className={`${classes.description}`}>{x.created_by}</Typography>

                        </Stack>
                    </Box>

                </Box>
            ))}
        </Box>
    );
}
